<template>
<main class="content-wrapper">
  <sidebar-modal :active.sync="showPanel" :title="sidebarTitle">
    <referral-details :referral="referral" />
  </sidebar-modal>
  <div class="flexcolumns">
    <margin-title :title="company" :subtitle="role" />
    <button class="button is-primary" @click="onViewClicked">
      View job
    </button>
  </div>
  <referrals-nav />
  <referrals-list :referrals="referrals" @select="onReferralClicked" />
</main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ReferralsList from '@/components/referrals/referrals-list'
import MarginTitle from '@/components/margin-title'
import Container from '@/components/general/container'
import ReferralsNav from '@/components/referrals/referrals-nav'
import ReferralDetails from '@/components/referrals/referral-details'
import SidebarModal from '@/components/sidebar-modal'

export default {
  components: {
    ReferralsList,
    MarginTitle,
    Container,
    ReferralsNav,
    ReferralDetails,
    SidebarModal
  },
  computed: {
    ...mapState('referrals', {
      referrals: 'currentJobReferrals',
      currentJob: 'currentJob'
    }),
    jobId () {
      return this.$route.params.jobId
    },
    company () {
      const job = this.currentJob || {}
      return job.companyName || ''
    },
    role () {
      const job = this.currentJob || {}
      return job.title || ''
    }
  },
  methods: {
    ...mapActions('referrals', [
      'getJobReferrals'
    ]),
    onReferralClicked (item) {
      if (item.email !== null) {
        this.sidebarTitle = item.email
      } else {
        this.sidebarTitle = `${item.userFirstName} ${item.userLastName}`
      }
      this.referral = item
      this.showPanel = true
    },
    onViewClicked () {
      this.$router.push(`/jobs/${this.jobId}`)
    }
  },
  mounted () {
    this.getJobReferrals(this.jobId)
  },
  data () {
    return {
      showPanel: false,
      referral: null,
      sidebarTitle: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.flexcolumns {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .button {
    width: 134px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/referrals/job-referrals.vue